<template>
    <div class="columns is-centered">
        <div class="column is-half">
            <h1 class="is-size-1">{{ lang('Login') }}</h1>

            <form class="form-horizontal" @submit.prevent="onSubmit">
                <div class="field">
                    <label class="label">{{ lang('Email') }}</label>
                    <div class="control">
                        <input v-model="loginData.email" class="input" :class="{'is-danger': formErrors.email}" type="email" name="email" required>
                    </div>
                    <p v-show="formErrors.email" v-for="error in formErrors.email" :key="error" class="help is-danger">
                        {{ error }}
                    </p>
                </div>

                <div class="field">
                    <label for="password" class="label">{{ lang('Password') }}</label>
                    <div class="control">
                        <input v-model="loginData.password" id="password" type="password" class="input" :class="{'is-danger': formErrors.password}" name="password" required>
                    </div>
                    <p v-show="formErrors.password" v-for="error in formErrors.password" :key="error" class="help is-danger">
                        {{ error }}
                    </p>
                </div>

                <div class="field">
					<div class="control">
						<label class="checkbox">
							<input v-model="loginData.remember" type="checkbox" name="remember"> {{ lang('Remember Me') }}
						</label>
					</div>
				</div>

                <div class="field is-grouped">
                    <div class="control">
                        <button type="submit" class="button is-primary">{{ lang('Login') }}</button>
                        <a class="button is-text" href="/password/reset">
                            {{ lang('Forgot Your Password?') }}
                        </a>
                    </div>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    name: "Login",
    data() {
        return {
            loginData: {
                email: "",
                password: "",
                remember: ""
            },
            formErrors: {}
        };
    },
    methods: {
        onSubmit() {
            var self = this;
            axios
                .post("/login", self.loginData)
                .then(function(response) {
                    if (response.data.redirect) {
                        window.location.href = response.data.redirect;
                    }
                })
                .catch(function(error) {
                    if (
                        error.response.status == 422 &&
                        error.response.data.errors
                    ) {
                        self.formErrors = error.response.data.errors;
                    } else {
                        console.log(error.response.data.message);
                    }
                });
        }
    }
};
</script>
